import moment from 'moment';

export const dateLong = raw => {
    return moment(raw).format('MMMM Do YYYY, H:mm:ss');
};

export const dateShort = raw => {
    return moment(raw).format('DD/MM/YYYY');
};

export function targetOrigin() {
    return '*';
};

export function getEditorUrl() {
    if (window.location.host === 'localhost:8080') {
        return 'http://127.0.0.1:3000/';
    } else {
        return 'https://pressage-dev.firebaseapp.com/';
    }
};

export function getPressageUrl(pressage) {
    return getEditorUrl() + `?load=${pressage.id}`;
};

export function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
};

export function getInstagramClientId() {
    return 'f1640d0f756548bfa930cc39fca8540f';
};

export const serialize = (index, id) => {
    let current = index.find(i => i.$id === id);
    const serialized = {};
    for (const prop in current) {
        if (current.hasOwnProperty(prop) && prop[0] !== '$') {
            serialized[prop] = current[prop];
        }
    }
    if (['bundle', 'container'].includes(current.type)) {
        serialized.children = [];
        index.filter(i => {
            return i.$level === current.$level + 1
                && i.$left > current.$left
                && i.$right < current.$right;
        }).sort((a, b) => {
            return a.$left - b.$left;
        }).forEach(i => {
            serialized.children.push(serialize(index, i.$id));
        });
    }
    return JSON.parse(JSON.stringify(serialized));
};

export const getPremadeImageSizeLimit = () => 1024 * 1024;

export const isProductionEnv = () => location.host === 'business.pressenger.com';

export const loadImage = (url, tag = undefined) => {
    return new Promise((resolve, reject) => {
        const image = new Image;
        image.tag = tag;
        image.onload = () => {
            image.success = true;
            resolve(image);
        };
        image.onerror = () => {
            image.success = false;
            resolve(image);
        };
        image.src = url;
    });
};

export const TwoFactorAuthErrorString = '$error check_ga Check GA token!';

export const buildAppUrl = (action, params) => {
    return `app://${action}` + params.reduce((prev, curr) => {
        let result = prev;
        if (curr[0] === '') {
            return result;
        }
        if (result === '') {
            result += '?';
        } else {
            result += '&';
        }
        result += `${curr[0]}=${encodeURIComponent(curr[1])}`;
        return result;
    }, '');
};

export const testUrlBuilder = (keys) => {
    const map = {};
    return keys.map(i => {
        if (i.length === 0) {
            return true;
        }
        if (/^[a-zA-Z0-9_]*$/.test(i) && !map[i]) {
            map[i] = true;
            return true;
        } else {
            return false;
        }
    });
};
